/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import{c as r}from"../../chunks/vec3f64.js";import{getWGS84ComparableLonLatProjector as n}from"./projectors.js";function o(r,o,c){if(null==o)return!1;const s=n(o);return null!=s&&(s(r,0,t,0),c!==t&&(c[0]=t[0],c[1]=t[1],c.length>2&&(c[2]=t[2])),!0)}const t=r();export{o as projectVectorToWGS84ComparableLonLat};
